export default __webpack_public_path__ + "static/media/doctors-office.07a8fcc8.png";